import React from 'react';
import MapComponent from "./components/MapComponent.js";
import { Authenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import outputs from './amplifyconfiguration.json';
import { generateClient } from 'aws-amplify/api';

import './App.css'; // Import the CSS file
import MenuBar from './components/MenuBar.js';
import { MapProvider } from "./components/Map/MapContext";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FeedbackPage from './components/Feedback/FeedbackPage.jsx';


Amplify.configure(outputs);
const client = generateClient({
  authMode: "userPool",
});

function App() {

  return (
    <Authenticator>
      <div className="app-container">

        <Router>
            <MenuBar />
            <Routes>
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/" element={(
                  <MapProvider>
                      <MapComponent />
                  </MapProvider>
              )} />
            </Routes>

            {/* <MapProvider>
              <MapComponent />
            </MapProvider> */}

        </Router>
      </div>
    </Authenticator>
  );

}

export default App;